export const PreferredPaymentMethodFormMessages = {
    SUCCESS_ALERT_MESSAGE: 'Preferred payment method set successfully.',
} as const;
